<template>
  <div class="content">
    <div class="select-file">
      文件名称：
      <a-select
        v-model="difyDocumentId"
        placeholder="请选择文件名称"
        style="margin-left: 10px; width: 600px"
        @change="onChange"
      >
        <a-select-option
          :value="item.difyDocumentId"
          v-for="item in fileList"
          :key="item.md5"
          :disabled="item.progress !== 100"
        >
          <div v-if="item.progress === 100">
            {{ item.name }}
          </div>
          <div class="select-option-item" v-else>
            <div class="title">{{ item.name }}</div>
            <div class="info">处理中...{{ item.progress }}%</div>
          </div>
        </a-select-option>
      </a-select>
    </div>
    <div class="comparison">
      <!-- <div class="comparison-item-left">
        <div class="title">
          原始文档预览
        </div>
        <div class="details"></div>
      </div> -->
      <div class="no-data" v-if="subsectionList.length === 0">
        <img src="@/assets/img/pic_zhishiku@2x.png" alt="" srcset="" />
        <div class="no-data-text">
          <div class="no-data-text-title">暂无分段数据</div>
        </div>
      </div>
      <div class="comparison-item-right" v-else>
        <div ref="details" class="details">
          <div class="total">共 {{ pagination.total }} 段</div>
          <div v-for="(item, index) in subsectionList" :key="index">
            <div class="subsection-item">
              <div class="subsection-item-title">
                #{{ (pagination.page - 1) * pagination.pageSize + index + 1 }} <span>{{ item.content.length }} 字符</span>
              </div>
              <div class="subsection-item-content">{{ item.content }}</div>
            </div>
          </div>
        </div>
        <Pagination class="list-pagination" :pagination.sync="pagination" @handleTableChange="handlePaginationChange" />
      </div>
    </div>
  </div>
</template>

<script>
import { getDocumentSegments, getDocumentEmbedProgress } from '@/api/aiApp.js'
import Pagination from '@/components/pagination/index.vue'
import { dataSet } from '@/data/app.js'
const dataSetId = dataSet.id

export default {
  name: 'Preview',
  props: {
    fileList: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Pagination
  },
  data() {
    return {
      difyDocumentId: '',
      subsectionList: [],
      pagination: {
        page: 1,
        pageSize: 50,
        total: 100
      },
      progressTimer: null,
      pendingCheckFiles: []
    }
  },
  mounted() {
    console.log('fileList', this.fileList)
    // 添加默认选中逻辑
    this.setDefaultSelection()
    this.pendingCheckFiles = [...this.fileList]
    this.startProgressCheck()
  },
  methods: {
    // 添加默认选中方法
    setDefaultSelection() {
      // 检查文件列表是否有数据
      if (this.fileList && this.fileList.length > 0) {
        // 查找第一个处理完成的文件（progress === 100）
        const completedFile = this.fileList.find(item => item.progress === 100)
        if (completedFile) {
          // 如果找到已完成的文件，则选中它
          this.difyDocumentId = completedFile.difyDocumentId
          // 触发选择变更事件，加载文件内容
          this.onChange()
        }
      }
    },
    onChange() {
      console.log('onChange', this.difyDocumentId)
      getDocumentSegments(
        {
          datasetId: dataSetId,
          documentId: this.difyDocumentId
        },
        {
          page: this.pagination.page,
          limit: this.pagination.pageSize
        },
        {
          'X-App-Id': 'dataset'
        }
      ).then(res => {
        if (res && res.data && res.data.length > 0) {
          this.subsectionList = res.data
          // this.pagination.total = res.total
          if (this.pagination.total <= 50) {
            this.$nextTick(() => {
              this.$refs.details.style.height = '100%'
            })
          }
        }
      })
    },
    handlePaginationChange() {
      this.onChange()
    },
     // 新增方法：启动进度检查
     startProgressCheck() {
      // 清除可能存在的旧定时器
      if (this.progressTimer) {
        clearInterval(this.progressTimer)
      }

      // 创建新的定时器
      this.progressTimer = setInterval(() => {
        // 如果没有需要检查的文件，可以考虑停止定时器
        if (this.pendingCheckFiles.length === 0) {
          clearInterval(this.progressTimer)
          this.progressTimer = null
          console.log('所有文件处理完成，停止检查')
          return
        }

        // 遍历待检查文件列表
        this.pendingCheckFiles.forEach((item, index) => {
          getDocumentEmbedProgress(
            { datasetId: dataSetId, batch: item.batch },
            {
              'X-App-Id': 'dataset'
            }
          )
            .then(res => {
              console.log('获取文件进度', res)
              if (!res) {
                // 如果res为undefined，标记文件为异常状态
                this.$set(item, 'status', 'error')
                this.$set(item, 'error', '获取进度失败')
                // 从待检查列表中移除
                this.pendingCheckFiles.splice(index, 1)
                return
              }
              if (res.data && res.data.length > 0) {
                const obj = res.data[0]

                // 处理完成的情况
                if (obj.indexing_status === 'completed') {
                  this.$set(item, 'progress', 100)
                  // 从待检查列表中移除此文件
                  this.pendingCheckFiles.splice(index, 1)
                  console.log(`文件 ${item.name} 处理完成，从检查列表中移除`)
                  this.$emit('ok')
                } else if (obj.indexing_status === 'indexing') {
                  // 正在处理的情况
                  item.completed_segments = obj.completed_segments
                  item.total_segments = obj.total_segments
                  item.error = obj.error
                  this.$set(item, 'progress', ((obj.completed_segments / obj.total_segments) * 100).toFixed(2))
                } else if (obj.indexing_status === 'error') {
                  this.$message.error('知识库文档处理失败，请重试')
                }
                // 其他状态不处理

                this.$forceUpdate()
              }
            })
            .catch(err => {
              console.error(`获取文件 ${item.name} 进度失败:`, err)
            })
        })
        console.log('待检查文件列表', this.pendingCheckFiles)
        console.log('文件列表', this.fileList)
      }, 2000)
    },
  }
}
</script>

<style lang="less" scoped>
.content {
  .select-file {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 14px;
    color: #000;
    margin-bottom: 20px;
    font-weight: bold;
  }
  .comparison {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;
    .comparison-item-left {
      width: 47%;
      .title {
        font-size: 16px;
        color: #000;
        margin-bottom: 10px;
        text-align: center;
        font-weight: bold;
      }
      .details {
        width: 100%;
        height: calc(100vh - 416px);
        border-radius: 4px;
        padding: 10px;
        background: #f7f7f7;
        overflow-y: auto;
      }
    }
    /deep/ .ant-select-selection-selected-value {
      color: #000;
    }
    .comparison-item-right {
      width: 100%;
      position: relative;
      .list-pagination {
        position: absolute;
        bottom: -15px;
        height: 40px;
        width: calc(100%);
      }
      .title {
        font-size: 16px;
        color: #000;
        margin-bottom: 10px;
        text-align: center;
        font-weight: bold;
      }
      .details {
        width: 100%;
        height: calc(100vh - 416px);
        border-radius: 4px;
        padding: 10px;
        background: #f7f7f7;
        overflow-y: auto;
        .total {
          color: #687f9c;
          margin: 12px 0;
          font-size: 16px;
          font-weight: bold;
        }
        .subsection-item {
          background: #fff;
          margin-bottom: 10px;
          border: solid 1px #f5f5f6;
          border-radius: 4px;
          padding: 10px;
          .subsection-item-title {
            font-size: 18px;
            color: #000;
            margin-bottom: 10px;
            font-weight: bold;
            span {
              color: #838383;
              font-size: 12px;
              font-weight: normal;
              padding-left: 10px;
            }
          }
          .subsection-item-content {
            font-size: 14px;
            color: #000;
            line-height: 1.8em;
          }
        }
      }
    }
    .no-data {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 100%;
      height: 500px;
      img {
        width: 200px;
        height: 200px;
      }
      .no-data-text {
        text-align: center;
        font-size: 14px;
        margin-top: -30px;
        font-weight: bold;
      }
    }
  }
}
</style>
<style lang="less">
.select-option-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title {
    color: #999999;
  }
  .info {
    font-size: 14px;
    color: #03b879;
    font-weight: normal;
    padding-left: 10px;
  }
}
</style>
